import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import classnames from "classnames";

import TopNav from "../containers/navs/Topnav";
import Sidebar from "../containers/navs/Sidebar";
import SidebarModern from "../containers/navs/SidebarModern";
import { OnboardingTour } from "../components/tour";
import FloatingChatWidget from "../containers/pages/ai-copilot/FloatingChatWidget";

class AppLayout extends Component {
  render() {
    const { containerClassnames, menuLayoutType, menuCollapsed } = this.props;
    const isModern = menuLayoutType === "modern-row";

    const layoutClasses = classnames(containerClassnames, {
      "layout-modern": isModern,
      "modern-expanded": isModern && !menuCollapsed,
      "modern-collapsed": isModern && menuCollapsed,
    });

    return (
      <div id="app-container" className={layoutClasses}>
        <TopNav history={this.props.history} />
        {isModern ? <SidebarModern /> : <Sidebar />}
        <main>
          <div className="container-fluid">{this.props.children}</div>
        </main>
        {/* Onboarding Tour for first-time users */}
        <OnboardingTour />
        {/* Global AI Copilot Floating Chat */}
        <FloatingChatWidget />
      </div>
    );
  }
}
const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuLayoutType, menuCollapsed } = menu;
  return { containerClassnames, menuLayoutType, menuCollapsed };
};
const mapActionToProps = {};

export default withRouter(
  connect(mapStateToProps, mapActionToProps)(AppLayout)
);
